<template>
	<div class="row" id="re-sheet">
		<div class="col-md-12 col-sm-12">
			<div class="card">
				<div class="card-body" style="border:none">
					<div class="row text-center">
						<div class="col-md-12 no-print">
							<a href="javascript:void(0)" class="btn btn-danger" v-print="printContent">{{ $t('ap.print') }}</a>
						</div>
					</div>
					
					<div class="row mrg-0">
						<div class="col-md-6">
							<div id="logo"><img src="/img/logo-small.svg" width="200" height="30" class="img-responsive" alt=""></div>
						</div>
						<div class="col-md-6">	
							<p id="invoice-info">
								<strong>{{ $t('reimbursement.name') }}:</strong> {{ data.name }} <br>
								<strong>{{ $t('reimbursement.team2') }}:</strong> {{ getTeam(data.team_id) }} <br>
							</p>
						</div>
					</div>
					<div class="row  mrg-0 detail-invoice" id="re-detail">
						<div class="col-md-12">
							<div class="invoice-table">
								<div class="table-responsive">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th>{{ $t('reimbursement.invoice-date') }}</th>
												<th>{{ $t('reimbursement.type') }}</th>
												<th>{{ $t('reimbursement.category') }}</th>
												<th>{{ $t('reimbursement.legal-entity') }}</th>
												<th>{{ $t('reimbursement.amount') }}</th>
												<th>{{ $t('reimbursement.comment') }}</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="re in data.approved">
												<td>{{ re.invoiceDate }}</td>
												<td>{{ re.typeName }}</td>
												<td>{{ re.category }}</td>
												<td>{{ re.legalEntity }}</td>
												<td>{{ re.amount }}</td>
												<td>{{ re.comment }}</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td>{{ $t('reimbursement.sum') }}</td>
												<td>&nbsp;</td>
												<td>&nbsp;</td>
												<td>&nbsp;</td>
												<td>{{ data.sum }}</td>
												<td>&nbsp;</td>
											</tr>
										</tfoot>
									</table>
								</div>										
							</div>
						</div>
						<div class="col-12 col-md-12">
							<hr>
							<h4>{{ $t('reimbursement.approve-by') }}: <img class="sign" v-if="data.sign != null" :src="data.sign" width="250px" /></h4><br>
							<h4>{{ $t('reimbursement.signature') }}: </h4><br>
							<h4>{{ $t('reimbursement.date') }}: </h4>
						</div>
					</div>
				</div>
			
			</div>
		</div>
	</div>
</template>
<style scoped>
@media print {
 	.no-print { display:none; }
 	html, body {
        height: inherit;
    }
    #re-sheet {
        height: inherit;
    }
    #re-detail {
        height: inherit !important;
    }
    .sign {
    	width: 250px;
    }
}
</style>
<script>
export default {
  name: 'ReimbursementSheet',
  props: ['data'],
  data: function() {
    return {
      printContent: {
        'id': 're-sheet',
        'popTitle': this.$t('reimbursement.re-sheet')
      }
    }
  },
  methods: {
    
  },
  created: function() {
  }
}
</script>
